var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"}],attrs:{"disabled":_vm.disabled,"placeholder":_vm.field.placeholder,"type":"text"},model:{value:(_vm.realValue),callback:function ($$v) {_vm.realValue=$$v},expression:"realValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }